import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '@chakra-ui/react';

import success from 'assets/brand/ok-hand.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';
import { root } from 'features/Bank/routes';
import * as helpRoutes from 'features/Help/routes';
import * as ContentLayout from 'layouts/ContentLayout';

import locales from './locales';

const DisputeSuccess: FC = () => {
  return (
    <ContentLayout.Root>
      <ContentLayout.Body size="sm">
        <SunshineCard.Group>
          <SunshineCard padding="space-32">
            <SunshineCard.Content alignItems="center" textAlign="center">
              <Image boxSize="200px" my="space-32" src={success} />
              <Heading marginBottom="space-16">{locales.title}</Heading>
              <Text variant="secondary">{locales.delay}</Text>
              <Text marginBottom="space-16" variant="secondary">
                {locales.followUp}
              </Text>
            </SunshineCard.Content>
          </SunshineCard>
          <SunshineCard>
            <SunshineCard.Content
              alignItems="center"
              gap="space-16"
              padding="space-16"
            >
              <Button
                as={Link}
                onClick={() =>
                  logEvent({ name: 'Click_Dispute_Transaction_Conversation' })
                }
                to={helpRoutes.root}
              >
                {locales.open}
              </Button>
              <Button
                as={Link}
                onClick={() =>
                  logEvent({ name: 'Click_Dispute_Transaction_Home' })
                }
                to={root}
                variant="inline-secondary"
              >
                {locales.back}
              </Button>
            </SunshineCard.Content>
          </SunshineCard>
        </SunshineCard.Group>
      </ContentLayout.Body>
    </ContentLayout.Root>
  );
};

export default DisputeSuccess;
